export default "__VITE_ASSET__t_LAmaTh__"